import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Alert,
  Spinner,
  Form,
  Table,
  OverlayTrigger,
  Tooltip,
  Button,
  Modal,
  Col,
  Row,
} from "react-bootstrap";
import {
  editCheckListDocGD,
  getEmpChecklist,
  saveCheckListDocGD,
} from "../../redux/employeeDocsChecklist/actions";
import LinkDescargaGD from "../gestorDocumental/LinkDescargaGD";
import { getFuncFichaEmpleado } from "../../redux/func_ficha_empleados/actions";
import CustomNavbar from "../../components/CustomNavbar";
import SidebarDashboard from "../../components/SidebarDashboard";
import UserHeadDetail from "../../components/UserHeadDetail";
import UserHeadDetailMenu from "../../components/UserHeadDetailMenu";
import config from "../../config";
import {
  getAreas,
  getCarpetas,
  getDocs,
  getSubNiveles,
} from "../../redux/gestorDocumental/actions";
import moment from "moment";
import { getEmployee } from "../../redux/employees/actions";
import { getBase64 } from "../../components/gestorDocumental/GestorDocumental";
import LinkDescargaListGD from "../gestorDocumental/LinkDescargaListGD";

const CheckListEmp = (props) => {
  const [edit, setEdit] = useState(false);
  const [editItem, setEditItem] = useState({});
  const [editItemGD, setEditItemGD] = useState({});
  const [showModalView, setShowModalView] = useState(false);
  const [editItemIndex, setEditItemIndex] = useState(0);
  // const [fileTemp, setFileTemp] = useState("");
  const [validated, setValidated] = useState(false);
  const [docs, setDocs] = useState([]);

  const [validFechaDoc, setValidFechaDoc] = useState(false);
  const [habilitarFecha, setHabilitarFecha] = useState(false);

  //Redux
  const dispatch = useDispatch();
  const data = useSelector((store) => store.funcTabEmployeed.ficha_empleado);
  const loading = useSelector(
    (store) => store.funcTabEmployeed.loadingFicha_Empleado
  );
  const checkListLoading = useSelector(
    (store) => store.employeeDocsCheckList.loading
  );
  const checkListEmp = useSelector(
    (store) => store.employeeDocsCheckList.checklistEmp
  );

  const userInfo = useSelector((store) => store.employees.employee);
  const userId = useSelector((store) => store.auth.id);

  const {
    areas,
    carpetas,
    // docs,
    subNiveles,
    areasError,
    carpetasError,
    error,
    formErrors,
    // loaderSubNiveles,
    loadingDocs,
    loadingAreas,
    loadingCarpetas,
    saveDocsLoading,
    subNivelesError,
  } = useSelector((store) => store.gestorDocumental);

  const {
    carpeta,
    // tipoDocumentoGD,
    tipoDocumento,
    // descripcion
  } = config.gestorDocumental.checklist;
  const { area, email } = config.gestorDocumental;

  useEffect(() => {
    dispatch(
      getFuncFichaEmpleado(
        props.match.params.id,
        parseInt(props.match.params.type)
      )
    );
    dispatch(
      getEmployee(
        parseInt(props.match.params.id),
        parseInt(props.match.params.type)
      )
    );
    if (userId) {
      dispatch(
        getDocs(
          { id_empleado: parseInt(userId), tipo_documento: "checkList" },
          setDocs
        )
      );
      dispatch(getAreas());
      dispatch(getCarpetas());
    }
  }, [dispatch, props.match.params.id, props.match.params.type, userId]);

  useEffect(() => {
    if (data && data.id) {
      dispatch(getEmpChecklist(data.id, parseInt(props.match.params.type)));
    }
  }, [dispatch, data, props.match.params.type]);

  useEffect(() => {
    if (areas && areas.length > 0 && carpetas && carpetas.length > 0) {
      const oCarpeta = carpetas.find(
        (item) => item.descripcion.toLowerCase() === carpeta.toLowerCase()
      );
      dispatch(
        getSubNiveles({
          areaid: areas[0].id,
          ceid: oCarpeta.id,
        })
      );
    }
  }, [areas, carpetas]);

  const onViewImg = (item, index) => {
    if (docs.length > 0) {
      const oItem = docs.find((item) => item.id_registro === editItem.id);
      if (oItem !== undefined) {
        setEdit(true);
        setEditItemGD(oItem);
      } else {
        setEdit(false);
      }
    }
    setHabilitarFecha(false);
    setEditItem(item);
    setEditItemIndex(index);
    setShowModalView(true);
    setValidated(false);
  };

  const onSubmitDocImg = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      if (
        e.target.documentos.files.length > 0 &&
        e.target.fechaDoc.value === ""
      ) {
        setValidFechaDoc(true);
      }
      setValidated(true);
      return;
    }
    if (
      e.target.documentos.files.length > 0 &&
      e.target.fechaDoc.value === ""
    ) {
      setValidFechaDoc(true);
      setValidated(true);
      return;
    }
    if (e.target.documentos.files.length === 0) {
      return;
    }

    const empresaT = userInfo.empresa[0];
    const oArea = areas.find(
      (item) => item.descripcion.toLowerCase() === area.toLowerCase()
    );
    const oCarpeta = carpetas.find(
      (item) => item.descripcion.toLowerCase() === carpeta.toLowerCase()
    );

    const filebase64 = await getBase64(e.target.documentos.files[0]);
    const fileName = e.target.documentos.files[0].name;
    const fName = String(fileName)
      .substring(0, String(fileName).lastIndexOf("."))
      .replace(/\W/g, "");
    const fExt = `.${String(fileName).substr(
      fileName.lastIndexOf(".") + 1 - fileName.length
    )}`;
    const aFileBase = String(filebase64).split(",");

    var chk = new FormData();
    chk.append("id_empleado", parseInt(props.match.params.id));
    chk.append("tipo_documento", tipoDocumento);
    chk.append("archivo", aFileBase[1]);
    chk.append("contentTypeGD", `${aFileBase[0]},`);
    chk.append("origen", fName + fExt);
    chk.append("extension", fExt);
    chk.append("tipo_documento_GD", e.target.tipoDocumentDesc.value);
    chk.append("descripcion", e.target.documentDesc.value);
    chk.append("fecha", moment().format("YYYY-MM-DD"));
    chk.append("id_area", oArea.id);
    chk.append("id_carpeta_encabezado", oCarpeta.id);
    chk.append("empresa", empresaT);
    chk.append("zona", userInfo.Division_Personal_List[0].descripcion);
    chk.append("id_registro", parseInt(editItem.id));
    const exist = e.target.documentos.files.length > 0;
    if (editItem && editItem.archivos_gestor) {
      dispatch(
        editCheckListDocGD(
          chk,
          editItem,
          editItemIndex,
          parseInt(props.type),
          editItem.archivos_gestor,
          exist
        )
      );
    } else {
      dispatch(
        saveCheckListDocGD(
          chk,
          editItem,
          parseInt(editItemIndex),
          parseInt(props.type),
          exist
        )
      );
    }
    e.target.reset();
    setEditItem({});
    setShowModalView(false);
  };

  const [show, setShow] = useState(false);
  const onShowSidebar = () => setShow(show ? false : true);
  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <div className="container mt-3 mb-3">
          {!!areasError && (
            <Alert variant="danger" className="mt-4 mb-1 mx-3">
              {areasError}
            </Alert>
          )}
          {!!carpetasError && (
            <Alert variant="danger" className="mt-4 mb-1 mx-3">
              {carpetasError}
            </Alert>
          )}
          {!!error && (
            <Alert variant="danger" className="mt-4 mb-1 mx-3">
              {error}
            </Alert>
          )}
          {loading ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : (
            <>
              <UserHeadDetail data={data} type={props.match.params.type} />
              <div className="my-4">
                <UserHeadDetailMenu
                  id={props.match.params.id}
                  type={props.match.params.type}
                />
                <div className="mt-4 mb-3">
                  <div className="d-flex aling-items-center justify-content-between px-2">
                    <h5 className="font-weight-bold text-uppercase">
                      CHECK LIST
                    </h5>
                    <div>
                      <span className="text-muted mr-3">
                        <i className="material-icons">vpn_key</i> Código:{" "}
                        {data.codigo}
                      </span>
                      <span className="text-muted mr-3">
                        <i className="material-icons">timer</i> Antigüedad:{" "}
                        {parseInt(data.antiguedad_laboral) < 1
                          ? ` ${parseInt(data.antiguedad_laboral)} meses`
                          : ` ${parseInt(
                              parseInt(data.antiguedad_laboral) / 12
                            )} años`}
                        {Math.floor(
                          (parseInt(data.antiguedad_laboral) / 12 -
                            parseInt(parseInt(data.antiguedad_laboral) / 12)) *
                            12
                        ) > 0
                          ? ` ${Math.floor(
                              (parseInt(data.antiguedad_laboral) / 12 -
                                parseInt(
                                  parseInt(data.antiguedad_laboral) / 12
                                )) *
                                12
                            )} meses`
                          : null}
                      </span>
                      <span className="text-muted">
                        <i className="material-icons">moving</i>{" "}
                        {data.Relacion_Laboral_List
                          ? data.Relacion_Laboral_List[0].descripcion
                          : "No ingresado aún"}
                      </span>
                    </div>
                  </div>
                  <hr className="mb-3" />
                  {checkListLoading ? (
                    <div className="d-flex justify-content-center">
                      <Spinner
                        animation="border"
                        role="status"
                        className="d-flex justify-content-center"
                      />
                    </div>
                  ) : checkListEmp.length === 0 ? (
                    <Alert className="my-4" variant="info">
                      Aún no hay documentos registrados
                    </Alert>
                  ) : (
                    <Table>
                      <thead>
                        <tr>
                          <th>Documentos</th>
                          <th>Estado</th>
                          <th></th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {checkListEmp.map((item, index) => (
                          <tr>
                            <td>{item.check_name}</td>
                            <td className="font-weight-bold">
                              {item.activo ? "Entregado" : "Pendiente"}
                            </td>
                            <td>
                              <Form.Check
                                disabled
                                defaultChecked={item.activo}
                                type="switch"
                                id={`custom-switch${item.id}`}
                              />
                            </td>
                            <td>
                              {!item.activo && (
                                <OverlayTrigger
                                  placement="bottom"
                                  overlay={
                                    <Tooltip {...props}>Subir archivo</Tooltip>
                                  }
                                >
                                  <Button
                                    size="sm"
                                    variant="link"
                                    type="button"
                                    className="text-primary btn rounded-pill"
                                    onClick={() => onViewImg(item, index)}
                                  >
                                    <i className="material-icons">upload</i>
                                  </Button>
                                </OverlayTrigger>
                              )}
                              {item.archivo_gestor && (
                                <LinkDescargaListGD
                                  id={item.id}
                                  filters={{
                                    email: email,
                                    id: item.archivo_gestor[0].id_documento,
                                    llave: item.archivo_gestor[0].llave,
                                  }}
                                  origen={item.archivo_gestor[0].origen}
                                  icono={<i className="material-icons">file</i>}
                                  cType={item.archivo_gestor[0].contentTypeGD}
                                />
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      <Modal
        size="md"
        show={showModalView}
        onHide={() => {
          setShowModalView(false);
        }}
      >
        <Form onSubmit={onSubmitDocImg} noValidate validated={validated}>
          <Modal.Header closeButton>
            <Modal.Title>
              <h4 className="font-weight-bold text-uppercase m-0">
                <i className="material-icons">file_upload</i>
                &nbsp;Subir archivo
              </h4>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {!!formErrors && (
              <Alert variant="danger" className="mt-4 mb-1 mx-3">
                {formErrors}
              </Alert>
            )}
            {!!subNivelesError && (
              <Alert variant="danger" className="mt-4 mb-1 mx-3">
                {subNivelesError}
              </Alert>
            )}
            <Form.Group as={Row}>
              <Form.Label column sm="12" md="4">
                Documento
              </Form.Label>
              <Col sm="12" md="8">
                <Form.File.Input
                  // accept="image/*"
                  name="documentos"
                  className="py-1"
                  required
                  disabled={
                    loadingDocs ||
                    loadingAreas ||
                    loadingCarpetas ||
                    saveDocsLoading ||
                    !(
                      subNiveles && subNiveles.subNivelTipoDocList.length > 0
                    ) ||
                    !(
                      subNiveles &&
                      subNiveles.subNivelDescripcionList.length > 0
                    )
                  }
                  onChange={(e) => {
                    if (e.currentTarget.files.length > 0) {
                      setHabilitarFecha(true);
                    } else {
                      setHabilitarFecha(false);
                    }
                  }}
                />
                <Form.Control.Feedback type="invalid">
                  <ul className="list-unstyled">
                    <li>**Es requerido un archivo de menor peso.</li>
                    <li>**Es requerido un archivo con formato pdf o imagen.</li>
                  </ul>
                </Form.Control.Feedback>
              </Col>
            </Form.Group>
            <Form.Group as={Row}>
              <Form.Label column sm="12" md="4">
                Descripción
              </Form.Label>
              <Col sm="12" md="8">
                <Form.Control
                  as="select"
                  name="documentDesc"
                  className="rounded-pill"
                  required={validFechaDoc}
                  defaultValue={edit ? editItemGD.Descripcion : null}
                  placeholder="Descripción del documento"
                  disabled={!habilitarFecha}
                >
                  <option value="" selected disabled>
                    Seleccione un descripción
                  </option>
                  {subNiveles &&
                    subNiveles.subNivelDescripcionList &&
                    subNiveles.subNivelDescripcionList.map((item, index) => (
                      <option key={index} value={item.descripcion}>
                        {item.descripcion}
                      </option>
                    ))}
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
              </Col>
            </Form.Group>
            <Form.Group as={Row}>
              <Form.Label column sm="12" md="4">
                Tipo de documento
              </Form.Label>
              <Col sm="12" md="8">
                <Form.Control
                  as="select"
                  name="tipoDocumentDesc"
                  className="rounded-pill"
                  required={validFechaDoc}
                  placeholder="Descripción del documento"
                  disabled={!habilitarFecha}
                >
                  <option value="" selected disabled>
                    Seleccione un tipo de documento
                  </option>
                  {subNiveles &&
                    subNiveles.subNivelTipoDocList &&
                    subNiveles.subNivelTipoDocList.map((item, index) => (
                      <option key={index} value={item.descripcion}>
                        {item.descripcion}
                      </option>
                    ))}
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
              </Col>
            </Form.Group>
            <Form.Group as={Row}>
              <Form.Label column sm="12" md="4">
                Fecha de entrega
              </Form.Label>
              <Col sm="12" md="8">
                <Form.Control
                  name="fechaDoc"
                  className="rounded-pill"
                  required={validFechaDoc}
                  type="date"
                  disabled={!habilitarFecha}
                  defaultValue={"2024-01-02"}
                ></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
              </Col>
            </Form.Group>
            {edit && editItem && editItem.archivo_gestor ? (
              <>
                <h6 className="text-muted ml-3">Archivo actual</h6>
                <ul className="list-unstyled">
                  <LinkDescargaGD
                    id={editItem.id}
                    filters={{
                      email: email,
                      id: editItem.archivo_gestor[0].id_documento,
                      llave: editItem.archivo_gestor[0].llave,
                    }}
                    origen={editItem.archivo_gestor[0].origen}
                    cType={editItem.archivo_gestor[0].contentTypeGD}
                  />
                </ul>
              </>
            ) : null}
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="rounded-pill"
              variant="secondary"
              onClick={() => setShowModalView(false)}
            >
              Cerrar
            </Button>
            <Button
              className="rounded-pill"
              disabled={
                loadingDocs ||
                loadingAreas ||
                loadingCarpetas ||
                saveDocsLoading ||
                areas === "" ||
                (areas && areas.length === 0) ||
                carpetas === "" ||
                (carpetas && carpetas.length === 0)
              }
              variant="primary"
              type="submit"
            >
              {loadingDocs ||
              loadingAreas ||
              loadingCarpetas ||
              saveDocsLoading ? (
                <Spinner
                  className="mr-2"
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : null}
              Guardar
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

export default CheckListEmp;
